import { render, staticRenderFns } from "./products-index.vue?vue&type=template&id=28121e7c&"
import script from "./products-index.vue?vue&type=script&lang=js&"
export * from "./products-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28121e7c')) {
      api.createRecord('28121e7c', component.options)
    } else {
      api.reload('28121e7c', component.options)
    }
    module.hot.accept("./products-index.vue?vue&type=template&id=28121e7c&", function () {
      api.rerender('28121e7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/stores/products-index.vue"
export default component.exports